/**
 * Soft≠Live Board ports — geometry footprints stay Soft; link/bound/state
 * come only from Live GET /devices/{id}/ports. Soft brochure camera titles /
 * Soft radio uplink theatre is deleted as truth.
 */

/** Soft geometry port id → Live BoardPort.port_id (hw_profile). */
export const SOFT_PORT_TO_LIVE = {
  eth_poe: "eth0",
  mipi_csi: "csi0",
  dsi: "dsi0",
  sd: "tf0",
  usbh: "usb0",
  uart_h: "uart0",
  gpio: "header40",
};

function portLiveTruth(live) {
  if (!live || typeof live !== "object" || !Object.keys(live).length) {
    return { state: "unknown", bound: null };
  }
  const st = String(live.state || live.status || "").toLowerCase();
  const up =
    live.up === true ||
    live.connected === true ||
    live.link === true ||
    st === "live" ||
    st === "up" ||
    st === "connected";
  const partial =
    live.partial === true || st === "partial" || st === "degraded" || st === "idle";
  const boundRaw =
    live.bound != null && String(live.bound).trim()
      ? String(live.bound)
      : live.link_label || live.summary || live.peer || live.ssid || live.camera || null;
  const bound = boundRaw != null && String(boundRaw).trim() ? String(boundRaw) : null;
  if (up) return { state: "live", bound: bound || "Live link reported" };
  if (partial) return { state: "partial", bound };
  if (bound) return { state: "partial", bound };
  if (st === "free" || st === "down" || live.up === false) {
    return { state: "free", bound: null };
  }
  return { state: "unknown", bound };
}

/**
 * Overlay Live ports catalogue onto Soft geometry PORTS rows.
 * Soft brochure state/bound never survive when a Live payload is present.
 *
 * @param {object[]} softPorts geometry rows from edge-data PORTS
 * @param {object|null} portsPayload GET /devices/{id}/ports body
 */
export function mergeLivePortsOntoSoftPorts(softPorts, portsPayload) {
  const items =
    (portsPayload && (portsPayload.items || portsPayload.ports)) || [];
  const byId = {};
  for (const it of items) {
    if (!it || typeof it !== "object") continue;
    const id = String(it.port_id || it.id || "").trim();
    if (id) byId[id] = it;
  }
  const hasPayload = portsPayload != null;

  return (softPorts || []).map((p) => {
    const liveId = SOFT_PORT_TO_LIVE[p.id] || null;
    const base = {
      ...p,
      state: "unknown",
      bound: null,
      soft: false,
      live_port_id: liveId,
      live: null,
    };
    if (!hasPayload) {
      return {
        ...base,
        honesty: "Awaiting Live GET /devices/{id}/ports — Soft brochure link theatre deleted",
      };
    }
    if (!liveId) {
      return {
        ...base,
        honesty: "Geometry-only footprint — no Live port_id on this board profile",
      };
    }
    const row = byId[liveId];
    if (!row) {
      return {
        ...base,
        honesty: "Live ports catalogue has no row for " + liveId,
      };
    }
    const live = row.live && typeof row.live === "object" ? row.live : {};
    const truth = portLiveTruth(live);
    return {
      ...base,
      state: truth.state,
      bound: truth.bound,
      live,
      live_label: row.label || p.label,
      live_kind: row.kind || null,
      honesty: "Live GET /devices/{id}/ports · " + liveId,
    };
  });
}

/** Geometry seed with Soft brochure state/bound stripped. */
export function geometryPortsSeed(ports) {
  return (ports || []).map((p) => ({
    ...p,
    state: "unknown",
    bound: null,
    soft: false,
    live: null,
    honesty: "Geometry only until Live GET /ports",
  }));
}
